import { jsx as _jsx } from "react/jsx-runtime";
import { BKJTextInput } from '../../BKJTextInput/index.js';
import { useRightIconProps } from '../BKJComboBox.utils.js';
import { useBKJComboBoxContext } from './BKJComboBox.context.js';
export const BKJComboBoxInput = ({ className, autoComplete, overrides, ...rest }) => {
    const { label, variant = 'ComboBoxSeamlessRounded', action, error, getComboboxProps, setAnchorElement, getInputProps, inputValue, getLabelProps, isOpen, onInputFocus, onInputKeyDown, selectedItem, name, leftIconProps, disabled, placeholder, required, isDropdownReverse, } = useBKJComboBoxContext();
    const isLabelValueHidden = overrides.includes('HIDE_VALUE_LABEL');
    const rightIconProps = useRightIconProps(action, disabled);
    const inputProps = getInputProps({
        ...rest,
        onKeyDown: onInputKeyDown,
        value: !isOpen && !isLabelValueHidden ? selectedItem?.label || '' : inputValue,
        onFocus: onInputFocus,
        ref: setAnchorElement,
        placeholder,
        required,
        name,
        label,
        disabled,
    });
    return (_jsx(BKJTextInput, { isOpen: isOpen, openBorderLocation: !!isDropdownReverse ? 'top' : 'bottom', labelProps: getLabelProps(), fieldSetProps: getComboboxProps(), variant: variant, ...inputProps, value: inputProps.value, autoComplete: autoComplete, className: `${inputProps.class} ${className}`, overrides: ['NO_REQUIRED'], rightIconProps: rightIconProps, leftIconProps: leftIconProps, error: error }));
};
//# sourceMappingURL=BKJComboBoxInput.js.map